export const SUBSCRIPTIONS_PRICES = {
  0: 595,
  1: 445,
  2: 275
};



// WEBPACK FOOTER //
// ./src/modules/examPrepDashboard/constants/subscription.js